export class Family {
  VariantReferenceID: number;
  FamilyName: string;
}
